<template>
  <div class="info-bar">
    <!-- <van-icon name="chat-o"  size="45" color="#ffffff"  />
    <van-icon name="good-job-o" size="45" />-->
    <div class="infobar-item infobar-item-title">
      @
      <span class="infobar-item-title-from">{{ handleFrom }}</span> ·
      <span class="infobar-item-title-date">{{ handleDate }}</span>
    </div>
    <div class="infobar-item infobar-item-text">
      <span>{{ title }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/zh-cn";

dayjs.locale("zh-cn");

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);

export default {
  props: ["title", 'from', 'publishDate'],
  computed: {
    handleDate() {
      let after = dayjs(+this.publishDate);

      if (after.$d == "Invalid Date") {
        after = dayjs(this.publishDate,'YYYY-MM-DD HH:mm:ss');
      }
      const now = dayjs();
      let diff = now.diff(after, "day");




      if (diff > 3) {
        return after.format("YYYY-MM-DD");
      } else {
        return after.fromNow();
      }
    },
    handleFrom() {
      return this.from == "" ? "映象网" : this.from
    }
  }
}
</script>

<style>
.info-bar {
  color: #ffffff;
  padding-left: 0.266667rem;
  padding-right: 0.266667rem;
  box-sizing: border-box;
  width: 100%;
}
.infobar-item {
  padding: 6px 0;
}
.infobar-item > .icon-yinfu {
  margin-right: 5px;
}

.infobar-item-title {
  font-size: 0.533333rem;
}

.infobar-item-title-from {
  font-weight: bold;
  font-size: 0.6rem;
}

.music-item {
  display: flex;
}

.infobar-item-text {
  font-size: 0.426667rem;
  line-height: 0.6rem;
}
</style>